import { Skeleton } from 'components';
import React from 'react';
import {
  SubscriptionContainer,
  SubscriptionDetails,
  SubscriptionButtonContainer,
} from '../styles';

const LoadingSkeleton = () => (
    <>
      <SubscriptionContainer>
        <SubscriptionDetails>
          <Skeleton title={false} paragraph={{ rows: 1, width: [30] }} />
          <Skeleton title={false} paragraph={{ rows: 1, width: [150] }} />
          <Skeleton title={false} paragraph={{ rows: 1, width: [100] }} />
        </SubscriptionDetails>
        <SubscriptionButtonContainer>
          <Skeleton title={false} paragraph={{ rows: 1, width: [110] }} />
        </SubscriptionButtonContainer>
      </SubscriptionContainer>
      <SubscriptionContainer>
        <SubscriptionDetails>
          <Skeleton title={false} paragraph={{ rows: 1, width: [30] }} />
          <Skeleton title={false} paragraph={{ rows: 1, width: [150] }} />
          <Skeleton title={false} paragraph={{ rows: 1, width: [100] }} />
        </SubscriptionDetails>
        <SubscriptionButtonContainer>
          <Skeleton title={false} paragraph={{ rows: 1, width: [110] }} />
        </SubscriptionButtonContainer>
      </SubscriptionContainer>
    </>
  );

export default LoadingSkeleton;
